export default __webpack_public_path__ + "static/media/sushi.29fdc6a4.jpg";